import { Rows3Icon, Rows4Icon, type LucideIcon } from 'lucide-react';

import { FOCUS_RING } from '@/shared/components/pillClasses';
import {
  usePreferencesStore,
  type TaskListDensity as Density,
} from '@/shared/store/preferences';

const OPTIONS: { value: Density; label: string; icon: LucideIcon }[] = [
  { value: 'cozy', label: 'Cozy', icon: Rows3Icon },
  { value: 'compact', label: 'Compact', icon: Rows4Icon },
];

/**
 * Two lines per row or one (spec 114 US2).
 *
 * Remembered on this device rather than written to the address: it is how
 * this person likes to read, and a shared link should never force it on the
 * next reader (FR-009). Not offered below tablet width, where the saved choice
 * still applies (FR-006).
 */
export function TaskListDensity() {
  const density = usePreferencesStore((state) => state.taskListDensity);
  const setDensity = usePreferencesStore((state) => state.setTaskListDensity);

  return (
    <div
      role="group"
      aria-label="Row density"
      className="border-input inline-flex h-7 shrink-0 items-center gap-0.5 rounded-lg border p-0.5 max-md:hidden"
    >
      {OPTIONS.map((option) => {
        const pressed = density === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={pressed}
            onClick={() => {
              setDensity(option.value);
            }}
            // Icons, named by label and tooltip (spec 127 FR-012): the two
            // words pushed the filter row onto a second line at 1440px.
            aria-label={option.label}
            title={`${option.label} rows`}
            className={`flex h-full items-center rounded-md px-1.5 transition-colors ${FOCUS_RING} ${
              pressed
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <option.icon
              aria-hidden="true"
              className="size-3.5"
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
}
